import React from "react";
import styled from "@emotion/styled";

const SelectedMemberInfo = ({selectedMemberInfoObj}) => {

  return (
    <MemberInfo>
      <InfoSection>
        <InfoHeader>
          <InfoEyebrow>Selected Member</InfoEyebrow>
          <InfoName>{selectedMemberInfoObj.fullName}</InfoName>
        </InfoHeader>
        <DetailRow>
          <DetailLabel>Date joined</DetailLabel>
          <DetailValue>{selectedMemberInfoObj.dateCreated}</DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>Last login</DetailLabel>
          <DetailValue>{selectedMemberInfoObj.lastLoginDate}</DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>Role</DetailLabel>
          <DetailValue>
            {selectedMemberInfoObj.role === 'admin' ?
              'Manager'
            : selectedMemberInfoObj.role === 'user' ?
              'User'
            :
              'Guest'
            }
          </DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>Email</DetailLabel>
          <DetailValue className="email">{selectedMemberInfoObj.email}</DetailValue>
        </DetailRow>
      </InfoSection>

      <InvestigationSection>
        <SectionTitle>Active Investigations</SectionTitle>
        <InvestigationGrid>
          <InvestigationMetric>
            <MetricLabel>Awaiting Action</MetricLabel>
            <MetricValue>{selectedMemberInfoObj.awaitingActionLeadsNum}</MetricValue>
          </InvestigationMetric>
          <InvestigationMetric>
            <MetricLabel>Under Investigation</MetricLabel>
            <MetricValue>{selectedMemberInfoObj.investigatingLeadsNum}</MetricValue>
          </InvestigationMetric>
          <InvestigationMetric>
            <MetricLabel>Closing</MetricLabel>
            <MetricValue>{selectedMemberInfoObj.closingLeadsNum}</MetricValue>
          </InvestigationMetric>
          <InvestigationMetric>
            <MetricLabel>Awaiting Update</MetricLabel>
            <MetricValue>{selectedMemberInfoObj.awaitingUpdateLeadsNum}</MetricValue>
          </InvestigationMetric>
          <InvestigationMetric>
            <MetricLabel>Awaiting Verification</MetricLabel>
            <MetricValue>{selectedMemberInfoObj.awaitingVerificationLeadsNum}</MetricValue>
          </InvestigationMetric>
        </InvestigationGrid>
      </InvestigationSection>
    </MemberInfo>
  )
}

const MemberInfo = styled.div(({ theme }) => `
  min-width: 0;
  display: grid;
  gap: 0.9rem;
  padding: 0.9rem 1rem 1rem;
  border-top: 0.1rem solid ${theme.palette.common.grayBorder};
  background: ${theme.palette.common.white};
`)

const InfoSection = styled.section(`
  min-width: 0;
  display: grid;
  gap: 0.55rem;
`)

const InfoHeader = styled.div(({ theme }) => `
  min-width: 0;
  padding-bottom: 0.25rem;
  border-bottom: 0.1rem solid ${theme.palette.common.grayBorderLight};
`)

const InfoEyebrow = styled.div(({ theme }) => `
  color: ${theme.palette.common.grayText};
  font-size: 0.72rem;
  font-weight: 800;
  line-height: 1.2;
  text-transform: uppercase;
`)

const InfoName = styled.h3(({ theme }) => `
  min-width: 0;
  margin: 0.15rem 0 0;
  overflow: hidden;
  color: ${theme.palette.common.black};
  font-size: 1.08rem;
  font-weight: 800;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
`)

const DetailRow = styled.div(`
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(5.5rem, auto) minmax(0, 1fr);
  gap: 0.75rem;
  align-items: baseline;
`)

const DetailLabel = styled.span(({ theme }) => `
  color: ${theme.palette.common.grayText};
  font-size: 0.82rem;
  font-weight: 700;
  line-height: 1.25;
`)

const DetailValue = styled.span(({ theme }) => `
  min-width: 0;
  color: ${theme.palette.common.black};
  font-size: 0.86rem;
  font-weight: 750;
  line-height: 1.25;
  text-align: right;

  &.email {
    overflow-wrap: anywhere;
  }
`)

const InvestigationSection = styled.section(({ theme }) => `
  min-width: 0;
  display: grid;
  gap: 0.6rem;
  padding-top: 0.85rem;
  border-top: 0.1rem solid ${theme.palette.common.grayBorder};
`)

const SectionTitle = styled.h3(({ theme }) => `
  margin: 0;
  color: ${theme.palette.common.black};
  font-size: 0.92rem;
  font-weight: 800;
  line-height: 1.25;
`)

const InvestigationGrid = styled.div(`
  min-width: 0;
  display: grid;
  gap: 0.45rem;
`)

const InvestigationMetric = styled.div(({ theme }) => `
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 0.6rem;
  align-items: center;
  padding: 0.55rem 0.65rem;
  border: 0.1rem solid ${theme.palette.common.grayBorder};
  border-radius: 0.65rem;
  background: ${theme.palette.common.cardBackground};
`)

const MetricLabel = styled.span(({ theme }) => `
  min-width: 0;
  overflow: hidden;
  color: ${theme.palette.common.grayText};
  font-size: 0.78rem;
  font-weight: 750;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
`)

const MetricValue = styled.span(({ theme }) => `
  color: ${theme.palette.common.black};
  font-size: 0.95rem;
  font-weight: 850;
  line-height: 1;
`)

export default SelectedMemberInfo
